module.exports = __webpack_public_path__ + "static/media/02_supermanha.f236ebf0.jpg";